// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const CustomerLayout = ({ children, title }) => {

	return (
		<div className='CustomerLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

CustomerLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

CustomerLayout.defaultProps = {
	children: null,
	title: ''
}

export default CustomerLayout